import React, { createContext, useState, useContext } from 'react';
import { KBData, LoadingKB, SynonymData, ToUpdateKB } from './AppState';
import { DropdownItemProps, MenuItemProps, MenuShorthandKinds, ShorthandCollection } from '@fluentui/react-northstar';

export interface AppStateKBValue {
  knowledgeBase: KBData[];
  synonyms: SynonymData[];
  templates: DropdownItemProps[];
  serviceOfferings: DropdownItemProps[];
  deletedKB: number[];
  editedKB: ToUpdateKB[];
  loadingKB: LoadingKB;
  tab: number;
  users: PlatformUser[];
  chatStudioData?: string;
  menuItems: ShorthandCollection<MenuItemProps, MenuShorthandKinds>;
} 
const defaultKBStateValue: AppStateKBValue = {
  knowledgeBase: [],
  synonyms: [],
  templates: [],
  serviceOfferings: [],
  deletedKB: [],
  editedKB: [],
  loadingKB: {
    message: "",
    isLoading: true,
  },
  tab: 0,
  users: [],
  chatStudioData: '',
  menuItems: [
    {
      key: 'qnapairs',
      content: 'All Knowledge',
    },
    {
      key: 'synonyms',
      content: 'Synonyms',
    },
    {
      key: 'chat',
      content: 'Chat Studio',
    }
  ]
}

export const AppKBStateContext = createContext(defaultKBStateValue);

export const AppSetKBStateContext = createContext<React.Dispatch<React.SetStateAction<AppStateKBValue>> | undefined>(undefined);

export const useSetKBState = () => {
  const setState = useContext(AppSetKBStateContext);
  if (!setState)
    throw new Error('useSetKBState was called outside of the AppSetKBStateContext provider');

  return setState;
};
export const kbState = () => {
  const state = useContext(AppKBStateContext);
  if (!state) {
    throw new Error(
      'useSetState was called outside of the AppSetKBStateContext provider'
    );
  }
  return state;
};

interface Props {
  children: any;
}

const AppKBStateProvider: React.FC<Props> = ({ children }) => {
  const [state, setState] = useState(defaultKBStateValue);
  return (
    <AppKBStateContext.Provider value={state}>
      <AppSetKBStateContext.Provider value={setState}>
        {children}
      </AppSetKBStateContext.Provider>
    </AppKBStateContext.Provider>
  );
};

export default AppKBStateProvider;